import { Avatar, AvatarProps } from '@mui/material'
import { useEffect, useState } from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  default: {
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 250ms ease-in-out',
  },
  loaded: {
    opacity: 1,
    visibility: 'visible',
  },
}))

interface SmartImageProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src?: string | null
  fallbackSrc: string
  className?: string
  avatar?: boolean
  variant?: AvatarProps['variant']
}

const SmartImage: React.FC<React.PropsWithChildren<SmartImageProps>> = ({
  src = '',
  fallbackSrc = '',
  className,
  alt = '',
  avatar,
  variant,
  ...rest
}) => {
  const { classes, cx } = useStyles()
  const [loaded, setLoaded] = useState(false)
  const [imgSrc, setImgSrc] = useState(src || '')

  useEffect(() => {
    setImgSrc(src || '')
  }, [src])

  const classNames = cx(className, classes.default, {
    [classes.loaded]: loaded || !src,
  })

  const onLoadHandler = () => {
    setLoaded(true)
  }

  const onErrorHandler = () => {
    setImgSrc(fallbackSrc)
  }
  if (!src) {
    return avatar ? (
      <Avatar
        variant={variant}
        alt={alt}
        src={fallbackSrc}
        className={classNames}
        {...rest}
      />
    ) : (
      <img alt={alt} src={fallbackSrc} className={classNames} {...rest} />
    )
  } else {
    return avatar ? (
      <Avatar
        {...rest}
        variant={variant}
        alt={alt}
        className={classNames}
        onError={onErrorHandler}
        onLoad={onLoadHandler}
        src={imgSrc}
      />
    ) : (
      <img
        {...rest}
        alt={alt}
        className={classNames}
        onError={onErrorHandler}
        onLoad={onLoadHandler}
        src={imgSrc}
      />
    )
  }
}

export default SmartImage
